module.exports = __webpack_public_path__ + "img/visual_analog.ad66d386.png";